import styled from 'styled-components'

export const IconWrapper = styled.div`
  width: ${({ width }) => (typeof width === 'number' ? `${width}px` : width || 'auto')};
  height: ${({ height }) => (typeof height === 'number' ? `${height}px` : height || 'auto')};
  background-color: ${({ wrapperColor }) => wrapperColor};
  display: flex;
  align-items: ${({ alignItems }) => alignItems};
  justify-content: ${({ justifyContent }) => justifyContent};
  border-radius: ${({ borderRadius }) => borderRadius};
  cursor: ${({ onClick }) => !!onClick && 'pointer'};
  margin: ${({ margin }) => margin};
  padding: ${({ padding }) => padding};
  flex-shrink: 0;

  &&.disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`
